import { render, staticRenderFns } from "./OrderDetailsModal.vue?vue&type=template&id=2e5a5a77"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=ts"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=ts"
import style0 from "./OrderDetailsModal.vue?vue&type=style&index=0&id=2e5a5a77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports